exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#list[data-v-6a74c572]{display:flex;flex-wrap:wrap;gap:1.8rem;padding:1rem;flex-basis:23.5%;width:98.25%;max-width:98.25%;min-height:75vh;height:auto;border:.15rem solid #000;margin-top:.5rem;background-color:#faedce}#list h1[data-v-6a74c572]{width:100%;text-align:center;font-size:4rem}@media only screen and (max-width:768px){#list[data-v-6a74c572]{width:87.2vw;flex-wrap:wrap}select[data-v-6a74c572]{width:20vw}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a74c572","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RecipeList.vue
// module id = 49
// module chunks = 0